import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Navbar } from "./components/site/Navbar";
import { Footer } from "./components/site/Footer";
import { AuthCallback } from "./components/site/AuthCallback";
import Home from "./pages/Home";
import Stations from "./pages/Stations";
import Simulation from "./pages/Simulation";
import Schedule from "./pages/Schedule";
import Videos from "./pages/Videos";
import Merch from "./pages/Merch";
import Gear from "./pages/Gear";
import Results from "./pages/Results";
import Program from "./pages/Program";
import Events from "./pages/Events";
import EventDetail from "./pages/EventDetail";
import AdminEvents from "./pages/AdminEvents";
import AdminOverview from "./pages/AdminOverview";
import AdminSignups from "./pages/AdminSignups";
import AdminMerch from "./pages/AdminMerch";
import AdminAffiliates from "./pages/AdminAffiliates";
import AdminSettings from "./pages/AdminSettings";
import AdminSubscribers from "./pages/AdminSubscribers";
import Support from "./pages/Support";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import SimulationFormat from "./pages/SimulationFormat";
import Blog from "./pages/Blog";
import BlogArticle from "./pages/BlogArticle";
import NotFound from "./pages/NotFound";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AppShell = () => {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/stations" element={<Stations />} />
          <Route path="/simulation" element={<Simulation />} />
          <Route path="/schedule" element={<Schedule />} />
          <Route path="/videos" element={<Videos />} />
          <Route path="/merch" element={<Merch />} />
          <Route path="/gear" element={<Gear />} />
          <Route path="/results" element={<Results />} />
          <Route path="/program" element={<Program />} />
          <Route path="/events" element={<Events />} />
          <Route path="/events/:slug" element={<EventDetail />} />
          <Route path="/admin" element={<AdminOverview />} />
          <Route path="/admin/events" element={<AdminEvents />} />
          <Route path="/admin/signups" element={<AdminSignups />} />
          <Route path="/admin/merch" element={<AdminMerch />} />
          <Route path="/admin/affiliates" element={<AdminAffiliates />} />
          <Route path="/admin/settings" element={<AdminSettings />} />
          <Route path="/admin/subscribers" element={<AdminSubscribers />} />
          <Route path="/support" element={<Support />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/simulation-format" element={<SimulationFormat />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogArticle />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <AppShell />
      <Toaster position="bottom-right" theme="dark" richColors />
    </BrowserRouter>
  );
}

export default App;
